import createTheme from "/lib/theme/createTheme";

const theme = (type = "light") => // Set default type to 'light'
    createTheme({
      palette: {
        type,

        // critical: {
        //   light: "#FFDAD4",  // Lighter red for light mode
        //   main: type === 'dark' ? "#FF0000" : "#FF5252", // Adjust main red based on theme
        //   dark: "#C41C1C",   // Dark red for both modes
        //   contrastText: "#FFFFFF",
        // },
        // error: {
        //   light: "#FFDAD4",  // Light red variant for light mode
        //   main: type === 'dark' ? "#C23138" : "#FF5252", // Adjust main red based on theme
        //   dark: "#C41C1C",   // Consistent dark shade for contrast
        //   contrastText: "#FFFFFF",
        // },
        warning: {
          light: "#FFE6CC",  // Lighter orange for light mode
          main: type === 'dark' ? "#DF913F" : "#FFA726", // Bright orange for light mode
          dark: "#F57C00",   // Dark orange for both modes
          contrastText: "#FFFFFF",
        },
        // unknown: {
        //   light: "#B3E5FC",  // Light blue for light mode
        //   main: type === 'dark' ? "#2b96d8" : "#29B6F6", // Adjust main blue based on theme
        //   dark: "#0288D1",   // Dark blue for both modes
        //   contrastText: "#FFFFFF",
        // },
        // success: {
        //   light: "#B9F6CA",  // Light green for light mode
        //   main: type === 'dark' ? "#1CAC78" : "#00E676", // Vivid green for light mode
        //   dark: "#00C853",   // Dark green for both modes
        //   contrastText: "#FFFFFF",
        // },
        // info: {
        //   light: "#81D4FA",  // Light blue for light mode
        //   main: type === 'dark' ? "#34B0CF" : "#039BE5", // Adjust main blue based on theme
        //   dark: "#0277BD",   // Dark blue for both modes
        //   contrastText: "#FFFFFF",
        // },

        primary: {
          light: "#81D4FA",
          main: type === 'dark' ? "#34B0CF" : "#039BE5", // Adjust main primary color based on theme
          dark: "#0277BD",
          contrastText: "#FFFFFF",
        },
        secondary: {
          light: "#FFFFFF",  // Light secondary color for light mode
          main: type === 'dark' ? "#057faf" : "#29B6F6", // Adjust secondary color based on theme
          dark: "#0288D1",
          contrastText: "#FFFFFF",
        },
        background: {
          default: type === 'dark' ? "#212D35" : "#F5F5F6", // Adjust default background based on theme
          paper: type === 'dark' ? "#3E4C55" : "#FFFFFF",  // Adjust paper background based on theme
        },
        divider: "#BDBDBD",
        // text: {
        //   primary: type === 'dark' ? "#FFFFFF" : "#212121", // Adjust primary text color based on theme
        //   secondary: type === 'dark' ? "#c1c0c0" : "#757575", // Adjust secondary text color based on theme
        // },
        // action: {
        //   disabled: "#E0E0E0",
        //   hover: type === 'dark' ? "#34B0CF" : "#E1F5FE", // Adjust hover color based on theme
        //   active: "#FFFFFF",
        // },
        contrastThreshold: 2,
      },
    });

export default theme;
